export const LG_WIDTH = 1024;
export const MD_WIDTH = 768;
export const SM_WIDTH = 640;
export const XS_WIDTH = 475;
